var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09436 12.0621C6.03221 11.6616 5.99996 11.2512 5.99996 10.8333C5.99996 6.41507 9.60525 2.83334 14.0526 2.83334C18.4999 2.83334 22.1052 6.41507 22.1052 10.8333C22.1052 11.8314 21.9213 12.7868 21.5852 13.6678C21.5154 13.8508 21.4804 13.9423 21.4646 14.0138C21.4489 14.0845 21.4428 14.1343 21.4411 14.2068C21.4394 14.2799 21.4493 14.3605 21.4692 14.5217L21.8717 17.7919C21.9153 18.1459 21.9371 18.3229 21.8782 18.4516C21.8266 18.5643 21.735 18.6539 21.6211 18.7028C21.4911 18.7588 21.3146 18.7329 20.9617 18.6812L17.7765 18.2143C17.6101 18.1899 17.527 18.1777 17.4512 18.1781C17.3763 18.1785 17.3245 18.1841 17.2511 18.1995C17.177 18.2151 17.0823 18.2505 16.893 18.3215C16.0097 18.6523 15.0524 18.8333 14.0526 18.8333C13.6344 18.8333 13.2237 18.8017 12.8227 18.7406M7.63158 22.8333C10.5965 22.8333 13 20.3709 13 17.3333C13 14.2958 10.5965 11.8333 7.63158 11.8333C4.66668 11.8333 2.26316 14.2958 2.26316 17.3333C2.26316 17.9439 2.36028 18.5313 2.53955 19.0801C2.61533 19.3121 2.65322 19.428 2.66566 19.5073C2.67864 19.59 2.68091 19.6365 2.67608 19.7201C2.67145 19.8001 2.65141 19.8906 2.61134 20.0717L2 22.8333L4.9948 22.4243C5.15827 22.402 5.24 22.3909 5.31137 22.3913C5.38652 22.3918 5.42641 22.3959 5.50011 22.4106C5.5701 22.4246 5.67416 22.4613 5.88227 22.5347C6.43059 22.7283 7.01911 22.8333 7.63158 22.8333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversations);
export default __webpack_public_path__ + "static/media/conversations.07dc9c5a32eb6d974ceefcb6dc05ed98.svg";
export { ForwardRef as ReactComponent };